import {
  buildHtml,
  buildImage,
} from '@amazeelabs/react-framework-bridge/gatsby';
import { BasicPage } from '@nuklear9/ui';
import { graphql } from 'gatsby';
import React, { ComponentProps, PropsWithChildren } from 'react';

import { drupalImageData } from '../../utils/drupal-image';

export const CoverBlock = graphql`
  fragment CoverBlock on DrupalCoverBlock {
    headline
    subtitle
    leadtext
    image {
      ...Image
    }
    imageCaption
    imageSource
  }
`;

export const mapCoverBlockFragmentToCoverProps = (
  cover: CoverBlockFragment,
): ComponentProps<typeof BasicPage>['cover'] => {
  const CoverImageLink = ({ children, ...props }: PropsWithChildren<{}>) => (
    <a
      href={cover?.image?.url || '#'}
      target="_blank"
      rel="noreferrer"
      {...props}
    >
      {children}
    </a>
  );
  return {
    Title: buildHtml(cover.headline || ''),
    Subtitle: cover.subtitle ? buildHtml(cover.subtitle) : undefined,
    Lead: cover.leadtext ? buildHtml(cover.leadtext) : undefined,
    figure: cover.image
      ? {
          Image: buildImage({
            image: drupalImageData(
              cover.image,
              'content',
              '(min-width: 1000px): 768px, 100vw',
            ),
            alt: cover.image?.translation?.alt || '',
          }),
          Link: CoverImageLink,
          caption: cover.imageCaption,
          source: cover.imageSource,
        }
      : undefined,
  };
};
